// extracted by mini-css-extract-plugin
export var container = "SupplierDetails-module--container--MRUpZ";
export var content = "SupplierDetails-module--content--brU4g";
export var header = "SupplierDetails-module--header--YfIch";
export var headerColumns = "SupplierDetails-module--headerColumns--vVFHF";
export var headerContent = "SupplierDetails-module--headerContent--5H3tu";
export var headerRight = "SupplierDetails-module--headerRight--Dl82I";
export var headerTopColumn = "SupplierDetails-module--headerTopColumn--QEn4X";
export var supplierProducts = "SupplierDetails-module--supplierProducts--JhEAP";